/**
 * Compute integer age from ISO / YYYY-MM-DD date of birth.
 * @param {string|null|undefined} dob
 * @returns {number|null}
 */
export function ageFromDob(dob) {
  if (dob == null || String(dob).trim() === '') return null;
  try {
    const parts = String(dob).trim().split(/[-/T]/).slice(0, 3).map((p) => parseInt(p, 10));
    if (parts.length < 3 || parts.some((n) => Number.isNaN(n))) return null;
    const [y, m, d] = parts;
    const born = new Date(y, m - 1, d);
    if (Number.isNaN(born.getTime())) return null;
    const today = new Date();
    let age = today.getFullYear() - born.getFullYear();
    const beforeBirthday =
      today.getMonth() < born.getMonth() ||
      (today.getMonth() === born.getMonth() && today.getDate() < born.getDate());
    if (beforeBirthday) age -= 1;
    return age >= 0 && age < 130 ? age : null;
  } catch (_) {
    return null;
  }
}

/**
 * Prefer explicit age; otherwise derive from DOB.
 * @param {number|string|null|undefined} age
 * @param {string|null|undefined} dob
 * @returns {number|null}
 */
export function resolveAge(age, dob) {
  if (age != null && String(age).trim() !== '') {
    const n = parseInt(age, 10);
    if (!Number.isNaN(n) && n >= 0 && n < 130) return n;
  }
  return ageFromDob(dob);
}
